var particle_softVS = `
		vDepth = getLinearDepth(localPos);
`;

export { particle_softVS as default };
